import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'; // Replaced Ant Design icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
// Removed Ant Design imports
// Removed Paragraph import
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useGlobalState } from '../../../store';
import BillingForm from '../components/BillingForm'; // Assuming refactored

import { API } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import SEO from '../../../components/SEO';
import { ReactComponent as Info } from '../../../images/svg/info.svg';
import { useLocalization } from '../../../localization';
// Added CB component imports
import { CBButton, CBHeader, CBModal, CBSpin } from '../../core/components/cbd'; // Added CBModal, CBSpin, CBAlert

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const SettingsPage = () => {
  const { t } = useLocalization();
  const navigate = useNavigate();
  const [user] = useGlobalState('user');
  const [license, setLicense] = useGlobalState('license');
  const [syncs] = useGlobalState('syncs');
  const [schedules] = useGlobalState('schedules');
  const [accounts] = useGlobalState('accounts');
  const [loadingCoreData] = useGlobalState('loadingCoreData');

  const [isCancelling, setIsCancelling] = useState(false); // Keep for button loading state
  const [billingSection, toggleBillingSection] = useState('status'); // Keep internal logic
  const [showChangeEmail, setShowChangeEmail] = useState(false);
  const [loadRedirect, setLoadRedirect] = useState(false); // Keep for portal button loading

  // Modal states
  const [showCancelTrialModal, setShowCancelTrialModal] = useState(false);
  const [showCancelSubModal, setShowCancelSubModal] = useState(false);
  const [showUnCancelModal, setShowUnCancelModal] = useState(false);
  const [showChangeEmailModal, setShowChangeEmailModal] = useState(false);
  const [emailToChangeTo, setEmailToChangeTo] = useState('');


  useEffect(() => {
    if (license != null) {
      if (license.trial) {
        toggleBillingSection('trial');
      } else {
        toggleBillingSection('status');
      }
    } else {
      toggleBillingSection('status');
    }
  }, [license]);

  // Functions to trigger confirmation modals (passed to BillingForm)
  function showCancelConfirm() {
    if (license.trial) {
      setShowCancelTrialModal(true);
    } else {
      setShowCancelSubModal(true);
    }
  }

  function showUnCancelConfirm() {
    setShowUnCancelModal(true);
  }

  // Loading state
  if (loadingCoreData || !license) { // Check for license existence too
    return (
      // Replaced Layout structure with div and flex centering
      <div className="cb-content-frame h-full flex items-center justify-center">
        <div className="cb-content-pane mobile_padding min-h-screen text-center">
          <CBHeader icon={<Info />} label={t('settings.title')} />
          {/* Replaced Spin with CBSpin */}
          <CBSpin
            spinning={true}
            size="large"
            
          />
        </div>
      </div>
    );
  }

  // --- Event Handlers ---
  async function getPortalUrl() {
    setLoadRedirect(true);
    try {
      
      const resp = await API.get('billing', '/billing?session=true');
      console.log(resp)
      
      window.open(resp.message, '_blank'); // Open in a new window/tab
    } catch (ex) {
      alert(t('settings.portal_access_error')); // Replaced message.error
    } finally {
      setLoadRedirect(false);
    }
  }

  async function handleUnCancel() {
    setShowUnCancelModal(false); // Close modal first
    setIsCancelling(true);
    try {
        const resp = await API.post('billing', '/billing', {
          body: { cancel: true, uncancel: true },
        });
        setLicense(resp.license);
        alert(t('settings.restore_sub_success_message')); // Replaced message.success
    } catch (error) {
        console.error("Error restoring subscription:", error);
        alert(error.response?.data?.message || "Failed to restore subscription.");
    } finally {
        setIsCancelling(false);
    }
  }

  async function handleCancel() {
    // Close relevant modal
    setShowCancelTrialModal(false);
    setShowCancelSubModal(false);
    setIsCancelling(true);
    try {
        const resp = await API.post('billing', '/billing', {
          body: { cancel: true },
        });
        setLicense(resp.license);
        if (resp.license.trial) {
          alert(t('settings.cancel_trial_success_message')); // Replaced message.success
          // Redirect or sign out after message
          setTimeout(() => window.location.href = "/dashboard", 1500);
        } else {
          const cancelDate = moment(resp.license.cancelEnd * 1000).format('LL');
          alert(t('settings.cancel_sub_success_message', { date: cancelDate })); // Replaced message.success
        }
    } catch (error) {
        console.error("Error cancelling:", error);
        alert(error.response?.data?.message || "Cancellation failed.");
    } finally {
        setIsCancelling(false);
    }
  }

  async function handleChangeEmailConfirm() {
      if (!emailToChangeTo) return;
      setShowChangeEmailModal(false);
      setIsCancelling(true); // Reuse loading state? Or add specific one?
      try {
          await API.post('account', '/account', {
              body: { code: 'rename', type: emailToChangeTo },
          });
          alert('Your email has been changed successfully. Please log in again.'); // Provide success feedback
          // Force reload or redirect to logout after success
          setTimeout(() => location.reload(), 1500);
      } catch (ex) {
          console.error("Error changing email:", ex);
          alert(ex.response?.data?.message || t('settings.change_email_error_exists')); // Use alert for error
      } finally {
          setIsCancelling(false);
          setEmailToChangeTo(''); // Clear selected email
      }
  }

  // --- Render Logic ---
  const isPremium = license.planId.includes('premium') || license.trial;
  const isPro = license.planId.includes('pro');
  var syncLegLimit = isPremium ? 16 : isPro ? 36 : 2;
  const isLegacy = !license.trial && (license.planId == 'calendarbridge-test' || license.planId == 'calendarbridge-pro');
  if (isLegacy) syncLegLimit = 14;
  const twoWayCount = syncs.filter((sync) => sync.twoWay === true).length;
  const syncLegCount = syncs.length + twoWayCount;

  // Removed pages object, logic moved directly into return

  if (!user) return <div>Loading user data...</div>; // Basic loading state for user

  return (
    // Replaced Layout structure with divs
    <div className="cb-content-frame bg-white">
      <SEO title={t('settings.seo_title')} />
      <div className="cb-content-pane mobile_padding">
        <CBHeader icon={<Info />} label={t('settings.title')} />
        <div>
          <div>
            <CBHeader label={t('settings.account_details_header')} subheader={true}/> {/* Added subheader */}
            <div className="flex flex-col lg:ml-4 gap-y-2 lg:text-lg mb-6"> {/* Added margin bottom */}
              <div className="flex flex-wrap gap-x-4 items-center font-sarabun ">
                <div className="text-lg w-32 flex-shrink-0">{t('settings.email_label')}</div>
                <div className="p-2 border rounded break-all">{license.email}</div>{' '}
                {license.orgId == 'single' &&
                  <CBButton type="link" onClick={e=>{ setShowChangeEmail(!showChangeEmail) }}>
                      {showChangeEmail ? t('common.cancel_button') : t('common.change_button')}
                  </CBButton>
                }
              </div>
              {showChangeEmail && <div className="pt-4 pl-4 pb-4 bg-neutral rounded mt-2">
                <p className="text-sm mb-2">{t('settings.change_email_select_account')}</p>
                {accounts.length === 0 && <div className="text-sm">{t('settings.no_connected_accounts')}</div>}
                {accounts.filter(account => account.email != license.email).map(account => (
                    <div className="flex flex-row gap-x-4 items-center m-2 text-sm" key={account.calendarAccountId}>
                        <span>{account.email}</span>
                        <CBButton
                            loading={isCancelling}
                            type="primary"
                            size="small"
                            onClick={() => {
                                setEmailToChangeTo(account.email);
                                setShowChangeEmailModal(true);
                            }}
                        >
                            {t('settings.use_this_email_button')}
                        </CBButton>
                    </div>
                ))}
                </div>}
              <div className="flex flex-wrap gap-x-4 items-center font-sarabun ">
                <div className="text-lg w-32 flex-shrink-0">{t('settings.organization_label')}</div>
                <div className="p-2 border rounded break-all">
                  {license.orgId === 'single' ? t('settings.org_individual') : license.orgId}
                </div>{' '}
              </div>
              <div className="flex flex-wrap gap-x-4 items-center font-sarabun ">
                <div className="text-lg w-32 flex-shrink-0">{t('settings.account_status_label')}</div>
                <div className="p-2 border rounded break-all">
                  {license.active ? t('settings.status_active') : t('settings.status_inactive')}{' '}
                  {license.state.includes('cancel_at_end') && (
                    <> - ({t('settings.status_cancelled_prefix')}{' '}{moment(license.cancelEnd * 1000).format('LL')})</>
                  )}
                </div>{' '}
              </div>
              {!license.trial && license.code !== 'site' && ( // Use !==
                <div className="flex flex-wrap gap-x-4 items-center font-sarabun ">
                  <div className="text-lg w-32 flex-shrink-0">{t('settings.referral_code_label')}</div>
                  <div className="p-2 bg-gray-100 border rounded break-all"> {/* Use bg-gray-100 */}
                    <>
                      {license.referralCode}{' '}
                      <a href="/dashboard/referrals" className="text-blue-600 hover:underline">{t('settings.view_referral_program_link')}</a>
                    </>
                  </div>{' '}
                </div>
              )}

            {!license.trial && (license.stripeUserId != 'site') && license.stripeUserId != 'trial' && (
                <div className="flex flex-col sm:flex-row gap-4 font-sarabun mt-4"> {/* Adjusted layout */}
                  <CBButton onClick={getPortalUrl} type="link" loading={loadRedirect}>{t('settings.update_billing_address_button')}</CBButton>
                  <CBButton onClick={getPortalUrl} type="link" loading={loadRedirect}>{t('settings.view_invoices_button')}</CBButton>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Billing Form Section */}
        <Elements stripe={stripePromise}>
          <BillingForm
            showCurrentPlan // Always show current plan details
            syncs={syncs.length}
            schedules={schedules.length}
            onCancel={showCancelConfirm} // Pass function to show modal
            onRestore={showUnCancelConfirm} // Pass function to show modal
          />
        </Elements>

      </div>

      {/* Modal Definitions */}
      <CBModal
          title={t('settings.cancel_trial_confirm_title')}
          visible={showCancelTrialModal}
          onPositiveClick={handleCancel}
          onCancelClick={() => setShowCancelTrialModal(false)}
          positiveLabel={t('settings.cancel_trial_button')}
          negativeLabel={t('common.nevermind_button')}
          positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }}
          confirmLoading={isCancelling} // Use loading state
        >
           <div className="flex items-center">
              <FontAwesomeIcon icon={faExclamationTriangle} className="text-yellow-500 text-xl mr-3" />
              <p>{t('settings.cancel_trial_confirm_message')}</p>
           </div>
       </CBModal>

       <CBModal
          title={t('settings.cancel_sub_confirm_title')}
          visible={showCancelSubModal}
          onPositiveClick={handleCancel}
          onCancelClick={() => setShowCancelSubModal(false)}
          positiveLabel={t('settings.cancel_sub_button')}
          negativeLabel={t('common.nevermind_button')}
          positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }}
          confirmLoading={isCancelling}
        >
           <div className="flex items-center">
              <FontAwesomeIcon icon={faExclamationTriangle} className="text-yellow-500 text-xl mr-3" />
              <p>{t('settings.cancel_sub_confirm_message')}</p>
           </div>
       </CBModal>

        <CBModal
          title={t('settings.restore_sub_confirm_title')}
          visible={showUnCancelModal}
          onPositiveClick={handleUnCancel}
          onCancelClick={() => setShowUnCancelModal(false)}
          positiveLabel={t('settings.restore_sub_button')}
          negativeLabel={t('common.nevermind_button')}
          // okType='danger' // Maybe not danger for restore? Default primary is fine.
          confirmLoading={isCancelling}
        >
           <div className="flex items-center">
              <FontAwesomeIcon icon={faExclamationTriangle} className="text-yellow-500 text-xl mr-3" />
              <p>{t('settings.restore_sub_confirm_message')}</p>
           </div>
       </CBModal>

       <CBModal
          title={t('settings.change_email_confirm_title_short')} // Shorter title
          visible={showChangeEmailModal}
          onPositiveClick={handleChangeEmailConfirm}
          onCancelClick={() => { setEmailToChangeTo(''); setShowChangeEmailModal(false); }}
          positiveLabel={t('settings.change_email_confirm_button')}
          negativeLabel={t('common.cancel_button')}
          positiveButtonProps={{ className: 'bg-blue-600 hover:bg-blue-700' }} // Use primary color
          confirmLoading={isCancelling}
        >
           <div className="flex items-center">
              <FontAwesomeIcon icon={faExclamationTriangle} className="text-blue-500 text-xl mr-3" />
              <p>{t('settings.change_email_confirm_message', { email: emailToChangeTo })}</p>
           </div>
       </CBModal>

    </div>
  )
}

export default SettingsPage;
